<template>
<div class="chapter">
<div class="inner_page">
<a id="page_iii"></a>
<h1 class="title">MARY QUEEN OF SCOTS’ SECRETARY</h1>
<p class="titlea"><span class="bold">SECRETARY</span></p>
<p class="titlea1"><span class="bold">WILLIAM MAITLAND</span></p>
<p class="titlea2"><span class="bold">POLITICIAN, REFORMER AND CONSPIRATOR</span></p>
<p class="author"><span class="bold">ROBERT STEDALL</span></p>
<div class="image_container">
<img alt="images" src="images/f0iii-01.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?54358d66